module.exports = __webpack_public_path__ + "img/symbol_8.2327c7b6.png";